import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonsService } from 'src/app/services/common.service';
import * as _ from 'lodash';
import { InteractionsService } from 'src/app/services/interactions.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {


  public interactions;
  private interactionsSubscriber;
  public interactionsOpened = null;

  constructor(
    private common: CommonsService,
    public interactionService: InteractionsService
  ) {
    this.common.setHeader('home');
  }

  ngOnInit(): void {

    // set welcomepage as visited in localStorage
   /* if (!localStorage.getItem('welcomePage')) {
      localStorage.setItem('welcomePage', 'true');
    }*/

    this.interactionsSubscriber = this.interactionService.interactions$.subscribe(interactions => {
      if (!interactions) {// the interactions were not been initializated
        // init the interactions Subject
        this.interactionService.getInteractions();
      } else {
        this.interactions = interactions;
        this.interactionsOpened = JSON.parse(this.interactionService.interactionsOpened);
      }
    });

  }

  clearCheck() {
    this.interactions.map(interaction => {
      interaction.opened = false;
      interaction.completed = false;
      return interaction;
    });
    this.interactionsOpened = [];
    localStorage.clear();
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
